const SHOP_KEY = "shop";

export default {
    getShop,
    setShop,
    clearShop,
    getInstallmentPricing,
    setInstallmentPricing
}

function getShop() {
    return JSON.parse(localStorage.getItem(SHOP_KEY) || "{}");
}

function setShop(shop) {
    localStorage.setItem(SHOP_KEY, JSON.stringify(shop));
}

function clearShop() {
    setShop(null);
}

function getInstallmentPricing() {
    return getShop().installmentPricing;
}

function setInstallmentPricing(installmentPricing) {
    let shop = getShop();
    shop.installmentPricing = installmentPricing;
    setShop(shop);
}